import React from 'react';
import { Container } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import './CommonChallenges.css';

const CommonChallenges: React.FC = () => {
  const { t } = useLanguage();

  const problems = [
    t('challenges.problem1'),
    t('challenges.problem2'),
    t('challenges.problem3'),
    t('challenges.problem4'),
    t('challenges.problem5'),
  ];

  return (
    <section className="challenges-section" id="challenges">
      <Container fluid="lg">
        <div className="challenges-header">
          <h2 className="challenges-title">{t('challenges.title')}</h2>
          <p className="challenges-subtitle">{t('challenges.subtitle')}</p>
        </div>

        <div className="challenges-list">
          {problems.map((problem, idx) => (
            <div key={idx} className="challenge-item">
              <div className="item-content">
                <div className="item-icon">●</div>
                <p className="item-text">{problem}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="challenges-footer-container">
          <p className="challenges-footer">{t('challenges.footer')}</p>
        </div>
      </Container>
    </section>
  );
};

export default CommonChallenges;
